import { createSlice } from '@reduxjs/toolkit';
import { ShiftScheduleState } from './shiftScheduleType';
import {
  createShiftSchedule,
  updateShiftSchedule,
  deleteShiftSchedule,
  fetchShiftScheduleById,
  fetchAllShiftSchedules
} from './shiftScheduleAction';

// Initial state
const initialState: ShiftScheduleState = {
  shiftSchedules: [],
  selectedShiftSchedule: undefined,
  loadingStates: {
    create: false,
    update: false,
    delete: false,
    fetchById: false,
    fetchAll: false
  },
  errors: {
    create: undefined,
    update: undefined,
    delete: undefined,
    fetchById: undefined,
    fetchAll: undefined
  }
};

// Slice
const shiftScheduleSlice = createSlice({
  name: 'shiftSchedule',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      // Create Shift Schedule
      .addCase(createShiftSchedule.pending, (state) => {
        state.loadingStates.create = true;
        state.errors.create = undefined;
      })
      .addCase(createShiftSchedule.fulfilled, (state, action) => {
        state.loadingStates.create = false;
        state.shiftSchedules.push(action.payload);
      })
      .addCase(createShiftSchedule.rejected, (state, action) => {
        state.loadingStates.create = false;
        state.errors.create = action.payload as string;
      })

      // Update Shift Schedule
      .addCase(updateShiftSchedule.pending, (state) => {
        state.loadingStates.update = true;
        state.errors.update = undefined;
      })
      .addCase(updateShiftSchedule.fulfilled, (state, action) => {
        state.loadingStates.update = false;
        const index = state.shiftSchedules.findIndex((schedule) => schedule.ScheduleID === action.payload.ScheduleID);
        if (index !== -1) {
          state.shiftSchedules[index] = action.payload;
        }
      })
      .addCase(updateShiftSchedule.rejected, (state, action) => {
        state.loadingStates.update = false;
        state.errors.update = action.payload as string;
      })

      // Delete Shift Schedule
      .addCase(deleteShiftSchedule.pending, (state) => {
        state.loadingStates.delete = true;
        state.errors.delete = undefined;
      })
      .addCase(deleteShiftSchedule.fulfilled, (state, action) => {
        state.loadingStates.delete = false;
        state.shiftSchedules = state.shiftSchedules.filter((schedule) => schedule.ScheduleID !== action.payload.ScheduleID);
      })
      .addCase(deleteShiftSchedule.rejected, (state, action) => {
        state.loadingStates.delete = false;
        state.errors.delete = action.payload as string;
      })

      // Fetch Shift Schedule by ID
      .addCase(fetchShiftScheduleById.pending, (state) => {
        state.loadingStates.fetchById = true;
        state.errors.fetchById = undefined;
      })
      .addCase(fetchShiftScheduleById.fulfilled, (state, action) => {
        state.loadingStates.fetchById = false;
        state.selectedShiftSchedule = action.payload;
      })
      .addCase(fetchShiftScheduleById.rejected, (state, action) => {
        state.loadingStates.fetchById = false;
        state.errors.fetchById = action.payload as string;
      })

      // Fetch All Shift Schedules
      .addCase(fetchAllShiftSchedules.pending, (state) => {
        state.loadingStates.fetchAll = true;
        state.errors.fetchAll = undefined;
      })
      .addCase(fetchAllShiftSchedules.fulfilled, (state, action) => {
        state.loadingStates.fetchAll = false;
        state.shiftSchedules = action.payload.data;
      })
      .addCase(fetchAllShiftSchedules.rejected, (state, action) => {
        state.loadingStates.fetchAll = false;
        state.errors.fetchAll = action.payload as string;
      });
  }
});

export default shiftScheduleSlice.reducer;
